import { useState } from "react";

function Messages() {

  const [messages, setMessages] = useState([]);

  const token = localStorage.getItem("token");

  const loadMessages = () => {

    fetch("http://localhost:5000/api/messages", {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => res.json())
      .then(data => setMessages(data))
      .catch(err => console.error(err));

  };


  const deleteMessage = (id) => {

    if (!window.confirm("Obrisati poruku?")) return;

    fetch(`http://localhost:5000/api/messages/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => res.json())
      .then(() => {
        loadMessages();
      });

  };

  return (

    <div>

      <h3 className="mb-4">Poruke</h3>

      <table className="table table-striped">

        <thead>
          <tr>
            <th>Ime</th>
            <th>Email</th>
            <th>Telefon</th>
            <th>Poruka</th>
            <th>Datum</th>
            <th></th>
          </tr>
        </thead>

        <tbody>

          {messages.map(msg => (

            <tr key={msg.ID}>
              <td>{msg.Ime}</td>
              <td>{msg.Email}</td>
              <td>{msg.Telefon}</td>
              <td>{msg.Body}</td>
              <td>{new Date(msg.created_at).toLocaleString()}</td>

              <td>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => deleteMessage(msg.ID)}
                >
                  Obriši
                </button>
              </td>
            </tr>

          ))}

        </tbody>

      </table>

    </div>

  );
}

export default Messages;